// import React, {Component} from 'react';
import {
  View,
  Text
} from 'react-native';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import c30v1a from './c30v1a'; // 団体情報
import i10v1a from './i10v1a'; // 設備情報
import i11v1a from './i11v1a'; // 時間帯情報
import i14v1a from './i14v1a'; // 設定情報

import c51v1a from './c51v1a';

import cView from './cView';

import myWB from './myWB_20211212';

import i1zv from './i1zv_20211024';

//export default class i1zv extends cView { // 設備予約　管理用用画面
export default class i1zv2 extends i1zv { // 設備予約　管理用用画面

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$id_stss = { // 親を上書き
  sb_agr: false,
};


// $opb_chk, render は個別に実装

$opb_chk = (pb_msg=true) => new Promise( _o_end1 => { // 

  const _o_this = this;

  ff.myCM_srl([
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2a']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['show'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        if (
          _d_i1zrs.d_flds.i1zrs11i == 20
        ) {
          if (pb_msg) alert(`予約がキャンセル済のため、指定された操作を行うことができません`);
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) && _o_this.state.sgcd_stgs?.b_alyPrd != true) {
        if (pb_msg) alert('エントリー受付期間外のため、指定された操作を行うことができません');
        _o_end2(false);
      }
      else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) && _o_this.state.sgcd_stgs?.b_pryPrd != true) {
        if (pb_msg) alert('優先エントリー受付期間外のため、指定された操作を行うことができません');
        _o_end2(false);
      }
      else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['show'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        if (
          _d_i1zrs.d_flds.i1zrs21i == 20
        ) {
          if (pb_msg) alert(`エントリーがキャンセル済のため、指定された操作を行うことができません`);
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['show'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        if (
          _d_i1zrs.d_flds.i1zrs22i == 20
        ) {
          if (pb_msg) alert(`優先エントリーがキャンセル済のため、指定された操作を行うことができません`);
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (_o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        //ff.l('1115: {}, {}, {}, {}, {}, {}, {}, {}'.f(
        //  ff.f(_d_i1zrs.d_flds.i1zri11s),
        //  ff.f(_d_i1zrs.d_flds.i1zri12s),
        //  ff.f(_d_i1zrs.d_flds.i1zri41s),
        //  ff.n(_d_i1zrs.d_flds.i1zri41i),
        //  ff.n(_d_i1zrs.d_flds.i1zrt41i),
        //  ff.n(_d_i1zrs.d_flds.i1zrb41f),
        //  ff.f(_d_i1zrs.d_flds.i1zri21d),
        //  ff.n(ff.myCM_getLen(_d_i1zrs.dld_cldDatsss.i1z0))
        //));
        if (
          ff.f(_d_i1zrs.d_flds.i1zri11s) == false ||
          ff.f(_d_i1zrs.d_flds.i1zri12s) == false ||
          ff.f(_d_i1zrs.d_flds.i1zri41s) == false ||
          ff.n(_d_i1zrs.d_flds.i1zri41i) < 1 ||
          ff.n(_d_i1zrs.d_flds.i1zrt41i) < 0 ||
          ff.n(_d_i1zrs.d_flds.i1zrb41f) < 1 ||
          ff.f(_d_i1zrs.d_flds.i1zri21d) == false ||
          ff.n(ff.myCM_getLen(_d_i1zrs.dld_cldDatsss.i1z0)) < 1
        ) {
          if (pb_msg) alert('入力されていない項目があるため、指定された操作を行うことができません');
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2a', 'i1zv2b', 'i1zv2c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        let _rsvDate = _d_i1zrs.d_flds.i1zri21d;
        if (
          ff.i(_rsvDate, _o_this.state.sl_hdys) == true
        ) {
          if (pb_msg) alert(`指定した利用日が休館日であるため、指定された操作を行うことができません`); 
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2a']) && _o_this.state.sgc_pnlMode == 'dtl') {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        if (_d_i1zrs.d_flds.i1zri21d < _o_this.state.sgcd_stgs.rsvSttDate || _d_i1zrs.d_flds.i1zri21d > _o_this.state.sgcd_stgs.rsvEndDate) {
          if (pb_msg) alert('予約受付対象外の利用日であるため、指定された操作を行うことができません');
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2a']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        let _rsvYearMth = ff.myDT_cnv('year-mth', _d_i1zrs.d_flds.i1zri21d);
        let _rsvMaxCnt = _o_this.state.sgcd_stgs.d_rsvMaxCnts[_rsvYearMth];
        i1zv2.op_loadSlcList({
          elm: 'i1zr',
          o_cnd: _dd_datss => {
            let _cnd = `i1zrb31f = ${_o_this.state.sgcd_cmnStgs.c10rb31f} AND i1zri21d LIKE "${_rsvYearMth}%" AND i1zrs11i IN (70, 80, 90)`;
            if (_o_this.state.sgc_pageMode == 'edit') _cnd += ` AND _fst <> ${_o_this.state.sgc_pageFst}`; // 自身以外の件数
            _cnd = cf.c('i1zr', _cnd);
            return _cnd;
          },
        })
        .then(() => {
          let _n_cnt = ff.myCM_getLen(_o_this.state.sdld_i1zrSlcListsss.i1zr);
          if (
            (_o_this.state.sgc_pageMode == 'new' && _n_cnt >= ff.n(_rsvMaxCnt)) ||
            (_o_this.state.sgc_pageMode == 'edit' && _n_cnt+1 > ff.n(_rsvMaxCnt))
          ) {
            if (pb_msg) alert(`予約が最大数（${_rsvMaxCnt}件）を超えているため、指定された操作を行うことができません`);
            _o_end2(false);
          } else { _o_end2(true); };
        })
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => { // 室の確認
//      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2a', 'i1zv2b']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2a', 'i1zv2b', 'i1zv2c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
        i1zv.op_chkSglI10r({
          d_i1zrs: _o_this.state.sdld_i1zrDtlsss?.i1zr[0],
          pageMode: _o_this.state.sgc_pageMode,
        })
        .then( _b_sgl => {
          if (
            _b_sgl == false
          ) {
            if (pb_msg) alert(`指定した室の時間帯に他の予約があるため、指定された操作を行うことができません`); 
            _o_end2(false);
          } else { _o_end2(true); };
        });

      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => { // 併用設備の確認
//      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2a', 'i1zv2b']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2a', 'i1zv2b', 'i1zv2c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
        i1zv.op_chkSglI10r2({
          d_i1zrs: _o_this.state.sdld_i1zrDtlsss?.i1zr[0],
          pageMode: _o_this.state.sgc_pageMode,
        })
        .then( _b_sgl => {
          if (
            _b_sgl == false
          ) {
            if (pb_msg) alert(`指定した設備の時間帯に他の予約があるため、指定された操作を行うことができません`); 
            _o_end2(false);
          } else { _o_end2(true); };
        });
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => { // 併用設備の重複の確認
//      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2a', 'i1zv2b']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2a', 'i1zv2b', 'i1zv2c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
        i1zv.op_chkSglI10r3({
          d_i1zrs: _o_this.state.sdld_i1zrDtlsss?.i1zr[0],
        })
        .then( _b_sgl => {
          if (
            _b_sgl == false
          ) {
            if (pb_msg) alert(`設備が重複して選択されているため、指定された操作を行うことができません`); 
            _o_end2(false);
          } else { _o_end2(true); };
        });
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) && _o_this.state.sgc_pnlMode == 'dtl') {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        if (ff.f(_d_i1zrs.d_flds.i1zri21d) && ff.myDT_cnv('year-mth', _d_i1zrs.d_flds.i1zri21d) != _o_this.state.sgcd_stgs.alyMth) {
          if (pb_msg) alert('エントリー受付対象外の利用日であるため、指定された操作を行うことができません');
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) && _o_this.state.sgc_pnlMode == 'dtl') {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        if (ff.f(_d_i1zrs.d_flds.i1zri21d) && ff.myDT_cnv('year-mth', _d_i1zrs.d_flds.i1zri21d) != _o_this.state.sgcd_stgs.pryMth) {
          if (pb_msg) alert('優先エントリー受付対象外の利用日であるため、指定された操作を行うことができません');
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        let _alyYearMth = ff.myDT_cnv('year-mth', _d_i1zrs.d_flds.i1zri21d);
        let _alyMaxCnt = _o_this.state.sgcd_stgs._02040300;
        i1zv2.op_loadSlcList({
          elm: 'i1zr',
          o_cnd: _dd_datss => {
            let _cnd = `i1zrb31f = ${_o_this.state.sgcd_cmnStgs.c10rb31f} AND i1zri21d LIKE "${_alyYearMth}%" AND i1zrs21i IN (40, 60, 80)`;
            if (_o_this.state.sgc_pageMode == 'edit') _cnd += ` AND _fst <> ${_o_this.state.sgc_pageFst}`; // 自身以外の件数
            _cnd = cf.c('i1zr', _cnd);
            return _cnd;
          },
        })
        .then(() => {
          let _n_cnt = ff.myCM_getLen(_o_this.state.sdld_i1zrSlcListsss.i1zr);
          if (
            (_o_this.state.sgc_pageMode == 'new' && _n_cnt >= ff.n(_alyMaxCnt)) ||
            (_o_this.state.sgc_pageMode == 'edit' && _n_cnt > ff.n(_alyMaxCnt))
          ) {
            if (pb_msg) alert(`エントリーが最大数（${_alyMaxCnt}件）を超えているため、指定された操作を行うことができません`);
            _o_end2(false);
          } else { _o_end2(true); };
        })
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        let _pryYearMth = ff.myDT_cnv('year-mth', _d_i1zrs.d_flds.i1zri21d);
        let _pryMaxCnt = _o_this.state.sgcd_stgs._02040300;
        i1zv2.op_loadSlcList({
          elm: 'i1zr',
          o_cnd: _dd_datss => {
            let _cnd = `i1zrb31f = ${_o_this.state.sgcd_cmnStgs.c10rb31f} AND i1zri21d LIKE "${_pryYearMth}%" AND i1zrs22i IN (40, 60, 80)`;
            if (_o_this.state.sgc_pageMode == 'edit') _cnd += ` AND _fst <> ${_o_this.state.sgc_pageFst}`; // 自身以外の件数
            _cnd = cf.c('i1zr', _cnd);
            return _cnd;
          },
        })
        .then(() => {
          let _n_cnt = ff.myCM_getLen(_o_this.state.sdld_i1zrSlcListsss.i1zr);
          if (
            (_o_this.state.sgc_pageMode == 'new' && _n_cnt >= ff.n(_pryMaxCnt)) ||
            (_o_this.state.sgc_pageMode == 'edit' && _n_cnt > ff.n(_pryMaxCnt))
          ) {
            if (pb_msg) alert(`優先エントリーが最大数（${_pryMaxCnt}件）を超えているため、指定された操作を行うことができません`);
            _o_end2(false);
          } else { _o_end2(true); };
        })
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (_o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        let _n_max = 0;
        let _n_min = ic.maxNmb;
        let _n_cnt = 0;
        _d_i1zrs.dld_cldDatsss.i1z0
        .filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false)
        .map( _d_i1z0s => {
          let _i110cx1i = (_d_i1z0s.dd_stgss?.i1z0b51f?.d_rfrs) ? _d_i1z0s.dd_stgss?.i1z0b51f?.d_rfrs.d_flds.i110cx1i : _d_i1z0s.d_flds.i110cx1i;
          if (_i110cx1i > _n_max) _n_max = _i110cx1i;
          if (_i110cx1i < _n_min) _n_min = _i110cx1i;
          _n_cnt += 1;
        });
        if (
          _n_cnt > 1 && (_n_max - _n_min) / (_n_cnt - 1) != 1
        ) {
          if (pb_msg) alert('時間帯が連続していないため、指定された操作を行うことができません');
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (_o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        let _n_cnt = 0;
        _d_i1zrs.dld_cldDatsss.i1z0
        .filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false)
        .map( _d_i1z0s => {
          _n_cnt += 1;
        });
        let _i10ri21i = (_d_i1zrs.dd_stgss?.i1zrb41f?.d_rfrs) ? _d_i1zrs.dd_stgss?.i1zrb41f?.d_rfrs.d_flds.i10ri21i : _d_i1zrs.d_flds.i10ri21i;
        if (
          _n_cnt > _i10ri21i
        ) {
          if (pb_msg) alert(`選択可能な時間帯が最大数（${_i10ri21i}件）を超えているため、指定された操作を行うことができません`);
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (_o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        if (
          _d_i1zrs.d_flds.i1zrs11i > 0 || _d_i1zrs.d_flds.i1zrs21i > 0 ||  _d_i1zrs.d_flds.i1zrs22i > 0
        ) {
          _o_end2(true);
        } else { 
          if (pb_msg) alert(`処理の途中でエラーが発生したため、一度ログアウトした後、再度操作を行ってください`);
          _o_end2(false);
        };
      } else { _o_end2(true); };
    }),
  ])
  .then( _b_res => {
    cf.myRN_setStt({
      sgcb_chk: _b_res,
    })
    .then(() => {
      _o_end1(_b_res);
    });
  });
}) 

render() {

  const _o_this = this;

  let _n_lblW = ic.s(2 * 4);
  let _n_cnt = 14;
  let _n_w1 = (ic.gn_bdyW - _n_lblW) / _n_cnt;

  let _r = [];
  _r = _o_this._o_rdrTime();

//ff.l('i1zv2 338: {}'.f(_o_this.state.sdld_i1zrDtlsss?.i1zr[0]?.d_flds));

  const _d_c30rs = _o_this.state.sdld_c30rDtlsss?.c30r[0];
  const _c30rc31s = (_d_c30rs) ? _d_c30rs.d_flds.c30rc31s : null; // 団体名
  const _i15rt11i = (_d_c30rs) ? _d_c30rs.d_flds.i15rt11i : null; // 利用料の有無 0:なし, 10:あり

  const _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
  const _i1zrc11s = (_d_i1zrs) ? _d_i1zrs.d_flds.i1zrc11s : null; // ID
  const _i1zri11m = (_d_i1zrs) ? _d_i1zrs.d_flds.i1zri11m : null; // 利用料
  const _i1z1i31d = (_d_i1zrs) ? _d_i1zrs.d_flds.i1z1i31d : null; // 支払期日
  const _i1z1s11i = (_d_i1zrs) ? _d_i1zrs.d_flds.i1z1s11i : null; // 支払状況

  //ff.l('I1zv2 365: {}'.f(_o_this.state.sgcd_stgs));
  return (
    ce.c(ce.RootDtl, 

      /* ----------------------------------------------------------------------------------------------------
      団体用 直接予約・エントリー
      ---------------------------------------------------------------------------------------------------- */
//      bf.i(_o_this.d_viewDefs.class, ['i1zv2a', 'i1zv2b']) ?
      bf.i(_o_this.d_viewDefs.class, ['i1zv2a', 'i1zv2b', 'i1zv2c']) ?
        {
          key: -1,
          d_hdrs: {
            pfx: 
              (_o_this.d_viewDefs.class == 'i1zv2a' && _o_this.state.sgc_pnlMode == 'list') ?
                '予約の確認、キャンセル・新規予約'
              : (_o_this.d_viewDefs.class == 'i1zv2a' && _o_this.state.sgc_pnlMode == 'dtl' && _o_this.state.sgc_pageMode == 'new') ?
                '新規予約'
              : (_o_this.d_viewDefs.class == 'i1zv2a' && _o_this.state.sgc_pnlMode == 'dtl') ?
                '直接予約'
              : (_o_this.d_viewDefs.class == 'i1zv2b' && _o_this.state.sgc_pnlMode == 'list') ?
                'エントリーの確認、キャンセル・新規エントリー'
              : (_o_this.d_viewDefs.class == 'i1zv2b' && _o_this.state.sgc_pnlMode == 'dtl' && _o_this.state.sgc_pageMode == 'new') ?
                '新規エントリー'
              : (_o_this.d_viewDefs.class == 'i1zv2b' && _o_this.state.sgc_pnlMode == 'dtl') ?
                'エントリー'
              : (_o_this.d_viewDefs.class == 'i1zv2c' && _o_this.state.sgc_pnlMode == 'list') ?
                '優先エントリーの確認、キャンセル・新規優先エントリー'
              : (_o_this.d_viewDefs.class == 'i1zv2c' && _o_this.state.sgc_pnlMode == 'dtl' && _o_this.state.sgc_pageMode == 'new') ?
                '新規優先エントリー'
              : (_o_this.d_viewDefs.class == 'i1zv2c' && _o_this.state.sgc_pnlMode == 'dtl') ?
                '優先エントリー'
              : null,
          },
          d_bdys: {
            l_clds: [

              // list ---------------------------------------------------------------------------------------------------
              ce.c(ce.Pnl, {
                key: -1,
                mode: 'list',
                b_vsb: _o_this.state.sgc_pnlMode == 'list' ? true : false,
                d_hdrs: {
                  b_vsb: false,
                },
                d_bdys: {
                  l_clds: [

                    ce.c(ce.Msg, {
                      key: -10,
                      b_vsb: true,
                      true : false,
                      pfx: `団体名：${(_o_this.state.sdld_c30rDtlsss?.c30r[0]) ? _o_this.state.sdld_c30rDtlsss?.c30r[0].d_flds.c30rc31s : ''}`,
                      stlCta: {
                        marginTop: ic.s(1),
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      },
                      stlPfx: {
                        textAlign: 'center',
                      },
                    }),

                    ce.c(ce.Box, {
                      key: -20,
                      d_stlCtas :{
                        marginTop: ic.s(1),
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderColor: ic.o_getCcd('e'),
                        borderWidth: ic.b(1),
                        padding: ic.s(0.5),
                      },
                    }, [
                      ce.c(ce.Msg, {
                        key: -10,
                        b_vsb: true,
                        true : false,
                        pfx: 
                          bf.i(_o_this.d_viewDefs.class, ['i1zv2a']) ?
                            _o_this.state.sgcd_stgs?.rsvMsg1
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) ?
                            _o_this.state.sgcd_stgs?.alyMsg1
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) ?
                            _o_this.state.sgcd_stgs?.pryMsg1
                          : null,
                        stlCta: {
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                        },
                        stlPfx: {
                          fontSize: ic.s(1.4),
                          textAlign: 'center',
                          color: ic.o_getCcd('e')
                        },
                      }),
                      ce.c(ce.Msg, {
                        key: -20,
                        b_vsb: true,
                        pfx: 
                          bf.i(_o_this.d_viewDefs.class, ['i1zv2a']) ?
                            _o_this.state.sgcd_stgs?.rsvMsg2
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) ?
                            _o_this.state.sgcd_stgs?.alyMsg2
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) ?
                            _o_this.state.sgcd_stgs?.pryMsg2
                          : null,
                        stlCta: {
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                        },
                        stlPfx: {
                          fontSize: ic.s(1.4),
                          textAlign: 'center',
                          color: ic.o_getCcd('e')
                        },
                      }),
                    ]),

                    ce.c(ce.Msg, {
                      key: -30,
                      b_vsb: true,
                      true : false,
                      pfx: 
                        bf.i(_o_this.d_viewDefs.class, ['i1zv2a']) ? 
                          _o_this.state.sgcd_stgs?._01010100
                        : bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) ? 
                          _o_this.state.sgcd_stgs?._02010100
                        : bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) ? 
                          _o_this.state.sgcd_stgs?._06010100
                        : null,
                      stlCta: {
                        marginTop: ic.s(1),
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                      },
                      stlPfx: {
                        textAlign: 'left',
                      },
                    }),

                    ce.c(ce.Spr, {
                      key: -35,
                      d_stlCtas: {
                        marginTop: ic.s(1),
                      },
                    }),

                    ce.c(ce.Msg, {
                      key: -40,
                      b_vsb: true,
                      true : false,
                      pfx: 
                        bf.i(_o_this.d_viewDefs.class, ['i1zv2a']) ? 
                          '現在の予約'
                        : bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) ? 
                          '現在のエントリー'
                        : bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) ? 
                          '現在の優先エントリー'
                        : null,
                      stlCta: {
                        marginTop: ic.s(1),
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      },
                      stlPfx: {
                        fontSize: ic.s(1.2),
                        textAlign: 'center',
                      },
                    }),

                    ce.c(cr.InpTree, {
                      key: -2,
                      state: 'sdld_i1zrSlcListsss',
                      d_stlCtas: {
                        marginTop: ic.s(1),
                        marginLeft: ic.m(1),
                        marginRight: ic.m(1),
                      },
                      dd_elmDefss: {
                        i1zr: {
                          elm: 'i1zr',
                          b_row: true,
                          b_ttl: false,
                          b_rootHdr: true,
                          d_stlRootHdrCtas: {
                            borderWidth: 0,
                            borderBottomWidth: ic.gn_bdrWNrw,
                            borderColor: ic.o_getCcd('d'),
                          },
                          d_stlRootBdyCtas: {
                            borderWidth: 0,
                            borderBottomWidth: ic.gn_bdrWNrw,
                            borderColor: ic.o_getCcd('d'),
                          },
                          dd_fldDefss: 
                            ( _o_this.d_viewDefs.class == 'i1zv2a') ? // 直接予約
                              cf.myRN_getFldDefs([
                                cf.f('i1zrc11s', {
                                  b_key: true,
                                  pfx: '予約ID',
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                }),
                                cf.f('i1zri21d', {
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                }),
                                cf.f('i1zri62s', {
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                }),
                                cf.f('i1zrb41f', {
                                  ld_iss: _o_this.state.sdld_i10rSlcListsss?.i10r,
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(14) : ic.s(14)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(14) : ic.s(14) },
                                }),
                              ])
                            : ( _o_this.d_viewDefs.class == 'i1zv2b') ? // エントリー
                              cf.myRN_getFldDefs([
                                cf.f('i1zrc11s', {
                                  b_key: true,
                                  pfx: 'エントリーID',
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                }),
                                cf.f('i1zri21d', {
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                }),
                                cf.f('i1zri62s', {
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                }),
                                cf.f('i1zrb41f', {
                                  ld_iss: _o_this.state.sdld_i10rSlcListsss?.i10r,
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(14) : ic.s(14)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(14) : ic.s(14) },
                                }),
                                cf.f('i1zrs21i', {
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                }),
                              ])
                            : ( _o_this.d_viewDefs.class == 'i1zv2c') ? // 優先エントリー
                              cf.myRN_getFldDefs([
                                cf.f('i1zrc11s', {
                                  b_key: true,
                                  pfx: '優先エントリーID',
//                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6)  },
//                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8) },
                                }),
                                cf.f('i1zri21d', {
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                }),
                                cf.f('i1zri62s', {
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                }),
                                cf.f('i1zrb41f', {
                                  ld_iss: _o_this.state.sdld_i10rSlcListsss?.i10r,
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(14) : ic.s(14)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(14) : ic.s(14) },
                                }),
                                cf.f('i1zrs22i', {
                                  d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                  d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                }),
                              ])
                            : null
                          ,
                        },
                      },
                    }),
                  ],
                },
                d_btms: {
                  d_news: {
                    elm: 'i1zr',
                    pfx: 
                      ( _o_this.d_viewDefs.class == 'i1zv2a') ?
                        '新規予約'
                      : ( _o_this.d_viewDefs.class == 'i1zv2b') ?
                        '新規エントリー'
                      : ( _o_this.d_viewDefs.class == 'i1zv2c') ?
                        '新規優先エントリー'
                      : null,
                    state: 'sdld_i1zrDtlsss',
                    opb_chkIns: _o_this.$opb_chk,
                    d_insFlds: {
                      ...cf.e('i1zr').d_insFlds, 
                      i1zrb31f: _o_this.state.sgcd_cmnStgs?.c10rb31f, // 団体用
//                      i1zrs11i: _o_this.d_viewDefs.class == 'i1zv2a' ? 80 : 0, // 直接予約：仮予約
//                      i1zrs21i: _o_this.d_viewDefs.class == 'i1zv2b' ? 40 : 0, // エントリー：エントリー済
//                      i1zrs22i: _o_this.d_viewDefs.class == 'i1zv2c' ? 40 : 0, // 優先エントリー：優先エントリー済
                      i1zrs11i: _o_this.d_viewDefs.class == 'i1zv2a' ? 80 : 0, // 直接予約：仮予約
                      i1zrs21i: _o_this.d_viewDefs.class == 'i1zv2b' ? 40 : 0, // エントリー：エントリー済
                      i1zrs22i: _o_this.d_viewDefs.class == 'i1zv2c' ? 40 : 0, // 優先エントリー：優先エントリー済
                    },                    
                    dld_cldDatsss: {
                      i1z2: { // 設備情報
                        elm: 'i1z2',
                        d_insFlds: {
                          ...cf.e('i1z2').d_insFlds, 
                        },
                      }
                    },
                    op_atrAll: () => new Promise( _o_end1 => {
                      _o_this._op_onChgI1zrb31f({
                        i1zrb31f: _o_this.state.sgcd_cmnStgs?.c10rb31f,
                      })
                      .then( () => {
                        _o_end1();
                      });
                    }),
                    d_stlBtns: {
                      width: ic.s(10),
                    },
                  },
                },
              }),

              // new, edit ---------------------------------------------------------------------------------------------------
              ce.c(ce.Pnl, {
                key: -2,
                mode: 'dtl',
                b_vsb:
                  ( 
                    _o_this.state.sgc_pnlMode == 'dtl' && 
                    bf.i(_o_this.state.sgc_pageMode, ['new', 'show', 'edit', 'hsy']) && 
                    _o_this.state.sgcn_step == 0
                  ) ?
                    true
                  : false,
                d_hdrs: {
                  b_vsb: false,
                },
                d_bdys:{

                  l_clds: [
                    
                    ce.c(ce.Msg, {
                      key: -10,
                      b_vsb: true,
                      true : false,
                      pfx: `団体名：${(_o_this.state.sdld_c30rDtlsss?.c30r[0]) ? _o_this.state.sdld_c30rDtlsss?.c30r[0].d_flds.c30rc31s : ''}`,
                      stlCta: {
                        marginTop: ic.s(1),
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      },
                      stlPfx: {
                        textAlign: 'center',
                      },
                    }),

                    ce.c(ce.Box, {
                      key: -20,
                      d_stlCtas: {
                        flex: 1,
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      },
                    }, [

                      ce.c(ce.Msg, {
                        key: -10,
                        b_vsb: true,
                        true : false,
                        pfx: 
                          bf.i(_o_this.d_viewDefs.class, ['i1zv2a']) & bf.i(_o_this.state.sgc_pageMode, ['new']) ?
                            _o_this.state.sgcd_stgs?._01020100
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2a']) & bf.i(_o_this.state.sgc_pageMode, ['edit']) ?
                            _o_this.state.sgcd_stgs?._01021100
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2a']) & bf.i(_o_this.state.sgc_pageMode, ['show']) ?
                            _o_this.state.sgcd_stgs?._01022100
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) & bf.i(_o_this.state.sgc_pageMode, ['new']) ?
                            _o_this.state.sgcd_stgs?._02020100
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) & bf.i(_o_this.state.sgc_pageMode, ['edit']) ?
                            _o_this.state.sgcd_stgs?._02021100
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) & bf.i(_o_this.state.sgc_pageMode, ['show']) ?
                            _o_this.state.sgcd_stgs?._02022100
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) & bf.i(_o_this.state.sgc_pageMode, ['new']) ?
                            _o_this.state.sgcd_stgs?._06020100
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) & bf.i(_o_this.state.sgc_pageMode, ['edit']) ?
                            _o_this.state.sgcd_stgs?._06021100
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) & bf.i(_o_this.state.sgc_pageMode, ['show']) ?
                            _o_this.state.sgcd_stgs?._06022100
                          : null
                        ,
                        stlCta: {
                          marginTop: ic.s(1),
                          flexDirection: 'column',
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                        },
                        stlPfx: {
                          textAlign: 'left',
                        },
                      }),

                      ce.c(ce.Spr, {
                        key: -15,
                        d_stlCtas: {
                          marginTop: ic.s(1),
                          width: ic.gn_minBdyW * 2,
                        },
                      }),

                      ce.c(ce.Msg, {
                        key: -17,
                        b_vsb: true,
                        true : false,
                        pfx: 
                          bf.i(_o_this.d_viewDefs.class, ['i1zv2a']) ? 
                            '予約情報'
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2b']) ? 
                            'エントリー情報'
                          : bf.i(_o_this.d_viewDefs.class, ['i1zv2c']) ? 
                            '優先エントリー情報'
                          : null,
                        stlCta: {
                          marginTop: ic.s(1),
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                        },
                        stlPfx: {
                          fontSize: ic.s(1.2),
                          textAlign: 'center',
                        },
                      }),

                      bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) ?
                        ce.c(ce.Msg, {
                          key: -5,
                          pfx: '「備品・駐車場」以外は全て必須項目',
                          d_stlCtas: {
                            marginTop: ic.s(1),
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                          },
                          d_stlPfxs: {
                            color: ic.o_getCcd('e'),
                            fontSize: ic.s(0.9),
                          },
                        })
                      : null,

                      ce.c(ce.Box, {
                        key: -20,
                        d_stlCtas: {
                          flex: 1,
                          flexDirection: 'column',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          marginTop: ic.s(1),
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }, 
                      }, [

                        ce.c(ce.Box, {
                          key: -10,
                          d_stlCtas: {
                            flex: 1,
                            width: ic.gn_minBdyW,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            paddingLeft: ic.m(1),
                            paddingRight: ic.m(1),
                          },
                        }, [

                          ce.c(cr.InpTree, {
                            key: -20,
                            b_vsb: 
                              bf.i(_o_this.state.sgc_pageMode, ['show', 'edit', 'hsy']), // new は非表示
                            state: 'sdld_i1zrDtlsss',
                            d_stlCtas: {
                              marginTop: ic.s(1),
                            },           
                            dd_elmDefss: {
                              i1zr: {
                                elm: 'i1zr',
                                b_row: (ic.g_dvcMode == 's') ? false : false,
                                d_cmns: (ic.g_dvcMode == 's') ? { n_cnt: 1 } : { n_cnt: 1 },
                                dd_fldDefss: 
                                  (_o_this.d_viewDefs.class == 'i1zv2a') ?
                                    cf.myRN_getFldDefs([
                                      cf.f('i1zrc11s', { // ID
                                        b_edit: false,
                                        d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6)  },
                                        d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7) : ic.s(5+24), n_h: (ic.g_dvcMode == 's') ? ic.s(2.2) : ic.s(2.2) },
                                      }),
                                      cf.f('i1zri11d', { // 申込日
                                        b_edit: false,
                                        d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                        d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(11) : ic.s(10+8+1), n_h: (ic.g_dvcMode == 's') ? ic.s(2.2) : ic.s(2.2) },
                                      }),
                                    ])
                                  : (_o_this.d_viewDefs.class == 'i1zv2b') ?
                                    cf.myRN_getFldDefs([
                                      cf.f('i1zrc11s', { // ID
                                        b_edit: false,
                                        d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6)  },
                                        d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7) : ic.s(5+24), n_h: (ic.g_dvcMode == 's') ? ic.s(2.2) : ic.s(2.2) },
                                      }),
                                      cf.f('i1zri11d', { // 申込日
                                        b_edit: false,
                                        d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                        d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(11) : ic.s(10+8+1), n_h: (ic.g_dvcMode == 's') ? ic.s(2.2) : ic.s(2.2) },
                                      }),
                                      cf.f('i1zrs21i', { // エントリー状況
//                                        b_vsb: (_o_this.d_viewDefs.class == 'i1zv2b') ? true : false,
                                        b_edit: false,
                                        d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6)  },
                                        d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(10+20), n_h: (ic.g_dvcMode == 's') ? ic.s(2.2) : ic.s(2.2) },
                                      }),
                                    ])

                                  : (_o_this.d_viewDefs.class == 'i1zv2c') ?
                                    cf.myRN_getFldDefs([
                                      cf.f('i1zrc11s', { // ID
                                        b_edit: false,
                                        d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6)  },
                                        d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7) : ic.s(5+24), n_h: (ic.g_dvcMode == 's') ? ic.s(2.2) : ic.s(2.2) },
                                      }),
                                      cf.f('i1zri11d', { // 申込日
                                        b_edit: false,
                                        d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                        d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(11) : ic.s(10+8+1), n_h: (ic.g_dvcMode == 's') ? ic.s(2.2) : ic.s(2.2) },
                                      }),
                                      cf.f('i1zrs22i', { // エントリー状況
//                                        b_vsb: (_o_this.d_viewDefs.class == 'i1zv2b') ? true : false,
                                        b_edit: false,
                                        d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6)  },
                                        d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(10+20), n_h: (ic.g_dvcMode == 's') ? ic.s(2.2) : ic.s(2.2) },
                                      }),
                                    ])

                                  : null,
                              },
                            },
                          }),

                          ce.c(cr.InpTree, {
                            key: -30,
                            state: 'sdld_i1zrDtlsss',
                            dd_elmDefss: {
                              i1zr: {
                                elm: 'i1zr',
                                b_row: (ic.g_dvcMode == 's') ? true : false,
                                d_cmns: (ic.g_dvcMode == 's') ? { n_cnt: 1 } : { n_cnt: 1 },
                                dd_fldDefss: cf.myRN_getFldDefs([
                                  cf.f('i1zri11s', { // 申込者
                                    ob_edit: _d_dats => 
                                      (bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && _d_dats.d_flds.i1zrs11i < 90) ? true : false,
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(11) : ic.s(11+8) },
                                  }),
                                  cf.f('i1zri12s', { // 連絡先
                                    pfx: '電話番号',
                                    ob_edit: _d_dats => 
                                      (bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && _d_dats.d_flds.i1zrs11i < 90) ? true : false,
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(21) : ic.s(21) },
                                  }),
                                ]),
                              },
                            },
                          }),

                          ce.c(ce.Box, {
                            key: -35,
                            d_stlCtas: {
                              width: ic.gn_bdyW,
                              flexDirection: 'column',
                              jusityContent: 'flex-start',
                              alignItems: 'flex-start',
                            },
                          },
                            ce.c(ce.Msg, {
                              key: -10,
                              pfx: '（記入例：090-0000-0000）',
                              d_stlPfxs: {
                                fontSize: ic.s(0.9),
                              },
                              d_stlCtas: {
                                width: ic.gn_bdyW - ic.s(6),
                                marginLeft: ic.s(6),
                                marginBottom: ic.s(0.1),
                              },
                            }),

                          ),

                          ce.c(cr.InpTree, {
                            key: -40,
                            state: 'sdld_i1zrDtlsss',
                            dd_elmDefss: {
                              i1zr: {
                                elm: 'i1zr',
                                b_row: (ic.g_dvcMode == 's') ? true : false,
                                d_cmns: (ic.g_dvcMode == 's') ? { n_cnt: 1 } : { n_cnt: 1 },
                                dd_fldDefss: cf.myRN_getFldDefs([
                                  cf.f('i1zri41s', { // 内容
                                    pfx: '利用目的',
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(11) : ic.s(10+1) },
                                  }),
                                  cf.f('i1zri41i', { // 人数
                                    pfx: '利用予定人数',
                                    bsd: '人',
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(7+4) },
                                  }),
                                ]),
                              },
                            },
                          }),

                          ce.c(cr.InpTree, {
                            key: -50,
                            state: 'sdld_i1zrDtlsss',
                            dd_elmDefss: {
                              i1zr: {
                                elm: 'i1zr',
                                b_row: (ic.g_dvcMode == 's') ? true : false,
                                d_cmns: (ic.g_dvcMode == 's') ? { n_cnt: 1 } : { n_cnt: 1 },
                                dd_fldDefss: cf.myRN_getFldDefs([
                                  cf.f('i1zrb41f', { // 室
                                    pfx: '室',
                                    b_dmy: true,
                                    ld_iss: _o_this.state.sdld_i10rSlcListsss?.i10r.filter( _d_i10rs => (_d_i10rs.d_flds.i10rt11i == 200) ? true : false),
                                    n_col: 14,
                                    b_tail: true,
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(14) : ic.s(14) },
                                    o_onChg: _d_dats => {
                                      i11v1a.op_loadSlcList({ // 時間帯
                                        elm: 'i110',
                                        i11r_fst: cf.myRN_getFldVal(_d_dats, 'i1zrb41f', 'i10rb51f', 'i10rb51f'),
                                      })
                                      .then(() => { // カレンダー

                                        _o_this.state.sdld_i110SlcListsss?.i110.map( (_d_i110s, _i110Idx) => { // 時間帯の初期化
                                          cf.myRN_setStt({
                                            [`s_time${_d_i110s.d_flds._fst}`]: 0,
                                          });
                                        });

                                        _o_this._op_loadCdrList2({
                                          state1: `sdld_cdrListsss2`,
                                          state2: `sl_dates2`,
                                        })
                                        .then(() => {
                                          _o_this._op_updI1z1i31m(); // 利用料・支払額の更新
                                        });
                                      })                                  
                                    }
                                  }),
                                ]),
                              },
                            },
                          }),

                          (ff.n(_o_this.state.sgcd_stgs?._00070100) == 10) ?
                            ce.c(cr.InpTree, {
                              key: -60,
                              b_vsb: true,
                              state: 'sdld_i1zrDtlsss',
                              dd_elmDefss: {
                                i1zr: {
                                  elm: 'i1zr',
                                  dd_cldDefss: {
                                    i1z2: {
                                      elm: 'i1z0',
                                      b_row: (ic.g_dvcMode == 's') ? true : true,
                                      b_subHdr: (ic.g_dvcMode == 's') ? false : false,
                                      b_ttl: (ic.g_dvcMode == 's') ? true : false,
                                      b_lyr: false,
                                      b_tail: true,
                                      d_btns: {
                                        d_btrs: {
                                          pfx: '備品・駐車場を追加',
                                          b_vsb: bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                                          d_stlCta: {
                                            marginLeft: ic.s(3),
                                          },
                                        },
                                        d_dlts: {
                                          b_vsb: bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                                        },
                                      },
                                      d_cmns: (ic.g_dvcMode == 's') ? { n_cnt: 1 } : { n_cnt: 1 },
                                      d_insFlds: cf.e('i1z0').d_insFlds,
                                      dd_fldDefss: cf.myRN_getFldDefs([
                                        cf.f('i1z2b41f', { // 設備
                                          pfx: '備品・駐車場',
                                          ld_iss: _o_this.state.sdld_i10rSlcListsss2?.i10r,
                                          n_col: 14,
                                          d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                          d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(14) : ic.s(14) },
                                          o_onChg: _d_dats => {
                                            cf.myRN_setDat('sdld_i1zrDtlsss', _d_dats, _d_dats => {
                                              let _d = {
                                                i1z2i12m: _d_dats.d_flds.i10ri11m,
                                              };
                                              return _d;
                                            })
                                            .then(() => {
                                              _o_this._op_loadCdrList2({
                                                state1: `sdld_cdrListsss2`,
                                                state2: `sl_dates2`,
                                              })
                                              .then(() => {
                                                _o_this._op_updI1z1i31m(); // 利用料・支払額の更新
                                              });
                                            });
                                          }
                                        }),
                                      ]),
                                    },
                                  },
                                },
                              },
                            })
                          : null,

                          ce.c(ce.Box, {
                            key: -80,
                            d_stlCtas: {
                              width: null,
                              maxWidth: null,
                              minWidth: null,
                              flexDirection : 'column', // here
                              justifyContent: 'flex-start', // here
                              alignItems: 'flex-start', // here
                            },
                          }, [
                            ce.c(cr.InpTree, {
                              key: -10,
                              state: 'sdld_i1zrDtlsss',
                              dd_elmDefss: {
                                i1zr: {
                                  elm: 'i1zr',
                                  b_row: (ic.g_dvcMode == 's') ? true : false,
                                  d_cmns: (ic.g_dvcMode == 's') ? { n_cnt: 1 } : { n_cnt: 1 },
                                  dd_fldDefss: cf.myRN_getFldDefs([
                                    cf.f('i1zri21d', { // 利用日
                                      pfx: '利用日時',
                                      o_onChg: _d_dats => {
                                        _o_this._op_loadCdrList2({
                                          state1: `sdld_cdrListsss2`,
                                          state2: `sl_dates2`,
                                          date: _d_dats.d_flds.i1zri21d,
                                        })
                                      },
                                      d_mdls: 
                                        (_o_this.d_viewDefs.class == 'i1zv2a') ?
                                          {
                                            iniDate: _o_this.state.sgcd_stgs?.rsvSttDate,
                                            sttDate: _o_this.state.sgcd_stgs?.rsvSttDate,
                                            endDate: _o_this.state.sgcd_stgs?.rsvEndDate,
                                          }
                                        : (_o_this.d_viewDefs.class == 'i1zv2b') ?
                                          {
                                            iniDate: _o_this.state.sgcd_stgs?.alyMthSttDate,
                                            sttDate: _o_this.state.sgcd_stgs?.alyMthSttDate,
                                            endDate: _o_this.state.sgcd_stgs?.alyMthEndDate,
                                          }
                                        : (_o_this.d_viewDefs.class == 'i1zv2c') ?
                                          {
                                            iniDate: _o_this.state.sgcd_stgs?.pryMthSttDate,
                                            sttDate: _o_this.state.sgcd_stgs?.pryMthSttDate,
                                            endDate: _o_this.state.sgcd_stgs?.pryMthEndDate,
                                          }
                                        : null,
                                      d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                      d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(9) : ic.s(8) },
                                    }),
                                  ]),
                                },
                              },
                            }),
                            ce.c(ce.Box, {
                              key: -20,
                              d_stlCtas: {
                                width: ic.gn_bdyW,
                                flexDirection: 'row',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                              }
                            },
                              ce.c(ce.Box, {
                                key: -10,
                                d_stlCtas: {
                                  width: ic.gn_bdyW - ic.s(6),
                                  flexDirection: 'row',
                                  justifyContent: 'flex-start',
                                  alignItems: 'center',
                                  flexWrap: 'wrap',
                                  paddingRight: ic.m(1),
                                  marginLeft: 'auto',
                                  marginRight: 0,
                                },
                              }, _r)
                            )
                          ]),

                          //(ff.f(_o_this.state.sdld_i1zrDtlsss.i1zr) && _o_this.state.sdld_i1zrDtlsss.i1zr[0].d_flds.i1zrt21i == '10') ?
                          (_i15rt11i == 10) ?
                          ce.c(cr.InpTree, {
                            key: -90,
                            state: 'sdld_i1zrDtlsss',
                            //b_vsb: (ff.f(_o_this.state.sdld_i1zrDtlsss.i1zr) && _o_this.state.sdld_i1zrDtlsss.i1zr[0].d_flds.i1zrt21i == '10') ? true : false,
                            //b_vbl: _i15rt11i == 10,
                            stlCta: {
                              marginTop: ic.s(2),
                            },
                            dd_elmDefss: {
                              i1zr: {
                                elm: 'i1zr',
                                d_cmns: (ic.g_dvcMode == 's') ? { n_cnt: 1 } : { n_cnt: 2 },
                                dd_fldDefss:
                                  cf.myRN_getFldDefs([
                                    cf.f('i1zri11m', {
                                      b_edit: false,
                                      bsd: '円',
                                      d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                      d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(16) : ic.s(7+5) },
                                    }),
                                  ])
                              },
                            },
                          })
                          : null,
                          //: null,

                          (_i15rt11i == 10) ?
                          ce.c(ce.Box, {
                            key: -100,
                            d_boxStls: {
                              flexDirection: 'row',
                              justifyContent: 'flex-start',
                              alignItems: 'center'
                            },
                          }, [
                            ce.c(ce.Msg, {
                              key: -10,
                              pfx: '支払状況',
                              d_pfxStls: {
                                fontSize: ic.s(0.9),
                                color: ic.c('d'),
                                fontWeight: 'bold',
                              },
                              d_ctrStls: {
                                width: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6),
                              }
                            }),
                            ce.c(ce.Pck, {
                              key: -20,
                              ctlVal: _i1z1s11i ?? 0,
                              ld_iss: [
                                { key:  -1, pfx: ' ' },
                                { key:   0, pfx: '未払' },
                                { key:  10, pfx: '支払済' },
                              ],
                              d_ctrStls: {
                                width: (ic.g_dvcMode == 's') ? ic.s(16) : ic.s(7+5),
                              }
                            })
                          ])
                          : null,

                        ]),

                      ])

                    ]),

                    ce.c(ce.Lbl, {
                      key: -100,
                      pfx: 
                        (_o_this.d_viewDefs.class == 'i1zv2a') ?
                          '予約状況'
                        : (_o_this.d_viewDefs.class == 'i1zv2b') ?
                          'エントリー状況'
                        : (_o_this.d_viewDefs.class == 'i1zv2c') ?
                          '優先エントリー状況'
                        : null
                      ,
                      b_vsb: (bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrb41f > 0) ? true : false,
                      stlCta: {
                        marginTop: ic.s(1), // 20211202
                      },
                      stlLbl: {
                      },
                    }),

                    (
                      bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && 
                      ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                      _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrb41f > 0 &&
                      ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d)
                    ) ?
                      ce.c(ce.Tbl2, {
                        key: -9,
                        pfx: `${(ff.f(_o_this.state[`sl_dates2`])) ? _o_this.state[`sl_dates2`][0] : ff.myDT_add('mth', ff.myDT_cnv('fdm', ff.myDT_getDate('today')), 2)} 〜`,
                        b_vsb: (bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrb41f > 0) ? true : false,
                        b_ctg: true,
                        b_tgt: true,
                        state: `sdld_cdrListsss2`,
                        l_cmns: _o_this.state[`sl_dates2`] ?? [],
                        o_hat: (_cmn, _cmnIdx) => (_cmnIdx == 0 || ff.myDT_cnv('day', _cmn) == 1) ? `${ff.myDT_cnv('mth', _cmn)}月` : '',
                        o_pfx: _cmn => `${ff.myDT_cnv('day', _cmn)}日`,
                        o_sfx: _cmn => {
                          let _s = 
                            ff.i( _cmn, _o_this.state.sl_hdys ) ?
                              '休館'
                            : `(${ff.myDT_cnv('dow', _cmn)})`;
                          return _s;
                        }, 
                        od_stlLbls: () => {
                          let _d = 
                            {
//                              flex: _n_lblW,
                              width: _n_lblW,
                              backgroundColor: ic.o_getCcd('h'),
                              paddingLeft: ic.m(1),
                              paddingRight: ic.m(1),
//                              backgroundColor: 'red',
                            };
                          return _d;
                          
                        },
                        od_stlCells: (_cmn, _cmnIdx) => {          
                          let _d = {
                            flex: _n_w1,
                            backgroundColor:
                              ff.i( _cmn, _o_this.state.sl_hdys ) ?
                                ic.g_ccdHN 
                              : ((_cmnIdx + 1) % 2 == 0) ? 
                                ic.o_getCcd('h') 
                              : ic.g_ccdWN,
                          };
                          return _d;
                        },
                        od_stlCtgRows: () => {          
                          let _d = {
                            minHeight: ic.s(2),
                          };
                          return _d;
                        },
                        od_stlDtlRows: () => {          
                          let _d = {
                              minHeight: ic.s(2),
                          };
                          return _d;
                        },
                      })
                    : null,

                  ],
                },

                d_btms:{
                  d_ctrStls : {
//                    height: ic.s(10),
//                    flex: 1,
                    height: 
                      ic.g_dvcMode == 's' ?
                        ic.s(5)
                      : ic.s(5),
//                    backgroundColor: 'red',

                  },
                  l_clds: [

                    bf.i(_o_this.state.sgc_pageMode, ['new']) ?
                      ce.c(View, {
                        key: -1,
                        style: {
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: ic.gn_minBdyW,
                          marginTop: ic.s(0.5), // 20211202
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }
                      }, [
                        ce.c(ce.Chk, {
                          key: -1,
                          frm: 'sqr',
                          o_onChg: _b_res => {
                            cf.myRN_setStt({
                              sb_agr: _b_res,
                            })
                          }
                        }),
                        ce.c(ce.Link, {
                          key: -2,
//                          url:`http://ufrsb.data-harness.com:3001/static/${myWB.myWB_getDmn().subDmn}/kiyaku.pdf`,
                          url:`${ic.g_url2}/${myWB.myWB_getDmn().subDmn}/kiyaku.pdf`,
                        }, [_o_this.state.sgcd_stgs?._00060100]),
                        ce.c(Text, {
                          key: -3,
                        }, ['を確認・同意する']),
                      ])
                    : null,

                      bf.i(_o_this.state.sgc_pageMode, ['show']) ?
                        ce.c(ce.Box, {
                          key: -155,
                          stlCta: {
                            flexDirection: 'row',
                            justifyContent: 'space-around', 
                            alignItems: 'flex-start',
                            flexWrap: 'wrap',
                            width: ic.gn_bdyW, // here
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }
                        }, [

                          ce.c(ce.Btn, {
                            key: -10,
                            pfx: '前の画面に戻る',
                            d_ctrStls: {
                            },
                            stlBtn: {
                              width: ic.s(8),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                            },
                            o_onPrs: () => {
                              cf.myRN_chgPnlMode({
                                mode: 'list',
                              });
                            },
                          }),

                          (
                            _o_this.d_viewDefs.class == 'i1zv2a' 
                            && _o_this.state.sgcd_stgs?._00100100 == '10' // 決済を使用
                            && _i15rt11i == 10 // 支払ありの団体種別
                            && _i1zri11m > 0 // 利用料あり
                            && _i1z1s11i != 10// 未払
//                            && _i1z1i31d >= ff.myDT_getDate('today')
                          ) ?
                          ce.c(ce.Btn, {
                            key: -15,
                            pfx: '事前決済(カード払い)',
                            d_ctrStls: {
//                              marginTop: ic.s(0.5), // 20220519
                            },
                            stlBtn: 
                            _i1z1s11i == 10 || ff.myDT_getDate('today') > _i1z1i31d ?
                            {
//                              height: ic.s(2),
                              width: ic.s(12),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                            }
                            :
                            {
//                              height: ic.s(2),
                              width: ic.s(12),
//                              backgroundColor: ic.g_ccdHN,
//                              borderColor: ic.g_ccdHN,
                            }
                            ,
                            o_onPrs:
                              _i1z1s11i == 10 || ff.myDT_getDate('today') > _i1z1i31d ?
                              null
                              : 
                              () => {
                                _o_this.setState({
                                  sgcd_mdls: bf.p(_o_this.state.sgcd_mdls, _next => {
                                    _next.srp = {
                                      b_showMdl: true,
                                      name: _c30rc31s,
                                      id: _i1zrc11s,
                                      amt: _i1zri11m,
                                      plcKey: _o_this.state.sgcd_stgs.c20ri31s,
                                      onScd: () => {
                                        cf.myRN_setDat('sdld_i1zrDtlsss', _d_i1zrs, _d_dats => {
                                          let _d = {
                                            i1z1s11i: 10,
                                            i1z1i41d: ff.myDT_getDate('today'),
                                            i1z1t51i: 20,
                                          };
                                          return _d;
                                        })
                                        .then(() => {
                                          _o_this._op_updI1zrs11i()
                                          .then(() => {
                                            _o_this.op_upd()
                                            .then(() => {
//                                              alert('支払いを完了しました');
                                              cf.myRN_showMdl({
                                                mdl: 'cfm',
                                                msg: '支払いが完了しました',
                                                ld_btnss: [
                                                  {
                                                    pfx: 'ＯＫ',
                                                    o_onPrs: () => { // 一覧には戻らない
                                                    },
                                                  },
                                                ]
                                              });
                                            });
                                          });
                                        })
                                      },
                                    };
                                  }),
                                }, () => {
                                  //ff.l('I1zv2 1410: {}'.f(_o_this.state.sgcd_mdls.srp));
                                });
                              },
                          })
                          : null,

                          (
                            _o_this.d_viewDefs.class == 'i1zv2a'
                            && _i1z1s11i != 10// 未払
                          ) ?
                          ce.c(ce.Btn, {
                            key: -20,
                            pfx: 'この予約をキャンセル',
                            d_ctrStls: {
//                              marginTop: ic.s(0.5), // 20220519
                            },
                            stlBtn: {
//                              height: ic.s(2),
                              width: ic.s(12),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                            },
                            o_onPrs: () => {
                              let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];
                              let _n_days = ff.myDT_getDff('day', ff.myDT_getDate('today'), _d_i1zrs.d_flds.i1zri21d);
                              if ( _d_i1zrs.d_flds.i1z1s11i == 10 || _n_days < ff.n(_o_this.state.sgcd_stgs._01040300) ) {
                                cf.myRN_showMdl({
                                  mdl: 'cfm',
                                  msg: `利用料の支払前、かつ、利用日から${_o_this.state.sgcd_stgs._01040300}日以上前の場合のみキャンセルできます(支払済の予約をキャンセルする場合は、電話か、直接窓口にお越しください)`,
                                  ld_btnss: [
                                    {
                                      pfx: 'はい',
                                      o_onPrs: () => {
                                      },
                                    },
                                  ]
                                });
                              }
                              else {
                                cf.myRN_showMdl({
                                  mdl: 'cfm',
                                  msg: 'キャンセルして宜しいですか？',
                                  ld_btnss: [
                                    {
                                      pfx: 'はい',
                                      o_onPrs: () => {
                                        cf.s();
                                        cf.myRN_setDat('sdld_i1zrDtlsss', _o_this.state.sdld_i1zrDtlsss.i1zr[0], _d_dats => {
                                          let _d = {
                                            i1zrs11i: 20,
                                          };
                                          return _d;
                                        })
                                        .then(() => {
//                                          _o_this.op_upd()
                                          _o_this.op_upd()
                                          .then(() => {
//ff.l('i1zv2 1408: {}'.f(_o_this.state.sgcd_stgs._00050310));
                                            if ( ff.n(_o_this.state.sgcd_stgs._00050310) == 10 ) {
//ff.l('i1zv2 1410: here');

                                              let _ttl = 
                                                `ご予約のキャンセルを受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`;
                                              let _msg = 
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
ご利用いただきまして誠にありがとうございます。
下記ご予約のキャンセルを受け付けましたので、ご連絡致します。

<<< ご予約内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${_o_this.state.sgcd_stgs._00050100}
-------------------------------------------------
`;
                                              const _l_tos = [];
                                              if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                              if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                              if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                              const _l_bccs = [ic.g_mail];
                                              if (ff.f(_o_this.state.sgcd_stgs._00050200)) _l_bccs.push(_o_this.state.sgcd_stgs._00050200);                                  
                                              //ff.l('I1zv1 2738: {} / {} / {} / {}'.f(_l_tos, _ttl, _msg, _l_bccs));
                                              cf.myCB_call_eml(
                                                _l_tos,
                                                _ttl,
                                                _msg,
                                                _l_bccs
                                              )
                                              .then(() => {
                                                _o_this.op_loadDtlAll({b_clr: false})
                                                .then(() => {
                                                  cf.myRN_savePageStgs({
                                                    sgc_pageMode: 'show',
                                                  })
                                                  .then(() => {
                                                    cf.myRN_chgPnlMode({
                                                      mode: 'list',
                                                    })
                                                    .then(() => {
                                                      cf.h();
                                                    });
                                                  });
                                                });
                                              })

                                            }
                                            else {
                                              _o_this.op_loadDtlAll({b_clr: false})
                                              .then(() => {
                                                cf.myRN_savePageStgs({
                                                  sgc_pageMode: 'show',
                                                })
                                                .then(() => {
                                                  cf.myRN_chgPnlMode({
                                                    mode: 'list',
                                                  })
                                                  .then(() => {
                                                    cf.h();
                                                  });
                                                });
                                              });
                                            };
                                          });
                                        })
                                      },
                                    },
                                    {
                                      pfx: 'いいえ',
                                      o_onPrs: () => {
                                      },
                                    }
                                  ]
                                });
                              }
                            },
                          })
                          : null,

                          (_o_this.d_viewDefs.class == 'i1zv2b') ?
                          ce.c(ce.Btn, {
                            key: -30,
                            pfx: 'このエントリーをキャンセル',
                            stlBtn: {
                              width: ic.s(14),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                              marginTop: ic.s(0.5), // 20220519
                            },
                            o_onPrs: () => {
                              let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];
                              let _today = ff.myDT_getDate('today');
                              if (  _d_i1zrs.d_flds.i1zrs21i != 40 || _today < _o_this.state.sgcd_stgs?.alySttDate || _o_this.state.sgcd_stgs?.alyEndDate < _today ) {
                                cf.myRN_showMdl({
                                  mdl: 'cfm',
                                  msg: `エントリー受付期間中のみキャンセルできます`,
                                  ld_btnss: [
                                    {
                                      pfx: 'はい',
                                      o_onPrs: () => {
                                      },
                                    },
                                  ]
                                });
                              }
                              else {
                                cf.myRN_showMdl({
                                  mdl: 'cfm',
                                  msg: 'キャンセルして宜しいですか？',
                                  ld_btnss: [
                                    {
                                      pfx: 'はい',
                                      o_onPrs: () => {
                                        cf.s();
                                        cf.myRN_setDat('sdld_i1zrDtlsss', _o_this.state.sdld_i1zrDtlsss.i1zr[0], _d_dats => {
                                          let _d = {
                                            i1zrs21i: 20,
                                          };
                                          return _d;
                                        })
                                        .then(() => {
//                                          _o_this.op_upd()
                                          _o_this.op_upd()
                                          .then(() => {

                                            if ( ff.n(_o_this.state.sgcd_stgs._00050310) == 10 ) {
                                              let _ttl = 
                                                `エントリーのキャンセルを受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`;
                                              let _msg = 
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
ご利用いただきまして誠にありがとうございます。
下記エントリーのキャンセルを受け付けましたので、ご連絡致します。

<<< エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${_o_this.state.sgcd_stgs._00050100}
-------------------------------------------------
`;
                                              const _l_tos = [];
                                              if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                              if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                              if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                              const _l_bccs = [ic.g_mail];
                                              if (ff.f(_o_this.state.sgcd_stgs._00050200)) _l_bccs.push(_o_this.state.sgcd_stgs._00050200);                                  
                                              cf.myCB_call_eml(
                                                _l_tos,
                                                _ttl,
                                                _msg,
                                                _l_bccs
                                              )
                                              .then(() => {
                                                _o_this.op_loadDtlAll({b_clr: false})
                                                .then(() => {
                                                  cf.myRN_savePageStgs({
                                                    sgc_pageMode: 'show',
                                                  })
                                                  .then(() => {
                                                    cf.myRN_chgPnlMode({
                                                      mode: 'list',
                                                    })
                                                    .then(() => {
                                                      cf.h();
                                                    });
                                                  });
                                                });
                                              });
                                            }
                                            else {
                                              _o_this.op_loadDtlAll({b_clr: false})
                                              .then(() => {
                                                cf.myRN_savePageStgs({
                                                  sgc_pageMode: 'show',
                                                })
                                                .then(() => {
                                                  cf.myRN_chgPnlMode({
                                                    mode: 'list',
                                                  })
                                                  .then(() => {
                                                    cf.h();
                                                  });
                                                });
                                              });
                                            }
                                          });
                                        })
                                      },
                                    },
                                    {
                                      pfx: 'いいえ',
                                      o_onPrs: () => {
                                      },
                                    }
                                  ]
                                });
                              }
                            },
                          })
                          : null,

                          (_o_this.d_viewDefs.class == 'i1zv2c') ?
                          ce.c(ce.Btn, {
                            key: -40,
                            pfx: 'この優先エントリーをキャンセル',
                            stlBtn: {
                              width: ic.s(16),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                              marginTop: ic.s(0.5), // 20220519
                            },
                            o_onPrs: () => {
                              let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];
                              let _today = ff.myDT_getDate('today');
                              if (  _d_i1zrs.d_flds.i1zrs22i != 40 || _today < _o_this.state.sgcd_stgs?.prySttDate || _o_this.state.sgcd_stgs?.pryEndDate < _today ) {
                                cf.myRN_showMdl({
                                  mdl: 'cfm',
                                  msg: `優先エントリー受付期間中のみキャンセルできます`,
                                  ld_btnss: [
                                    {
                                      pfx: 'はい',
                                      o_onPrs: () => {
                                      },
                                    },
                                  ]
                                });
                              }
                              else {
                                cf.myRN_showMdl({
                                  mdl: 'cfm',
                                  msg: 'キャンセルして宜しいですか？',
                                  ld_btnss: [
                                    {
                                      pfx: 'はい',
                                      o_onPrs: () => {
                                        cf.s();
                                        cf.myRN_setDat('sdld_i1zrDtlsss', _o_this.state.sdld_i1zrDtlsss.i1zr[0], _d_dats => {
                                          let _d = {
                                            i1zrs22i: 20,
                                          };
                                          return _d;
                                        })
                                        .then(() => {
                                          _o_this.op_upd()
                                          .then(() => {

                                            if ( ff.n(_o_this.state.sgcd_stgs._00050310) == 10 ) {

                                              let _ttl = 
                                                `優先エントリーのキャンセルを受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`;
                                              let _msg = 
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
ご利用いただきまして誠にありがとうございます。
下記優先エントリーのキャンセルを受け付けましたので、ご連絡致します。

<<< 優先エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${_o_this.state.sgcd_stgs._00050100}
-------------------------------------------------
`;
                                              const _l_tos = [];
                                              if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                              if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                              if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                              const _l_bccs = [ic.g_mail];
                                              if (ff.f(_o_this.state.sgcd_stgs._00050200)) _l_bccs.push(_o_this.state.sgcd_stgs._00050200);                                  
                                              cf.myCB_call_eml(
                                                _l_tos,
                                                _ttl,
                                                _msg,
                                                _l_bccs
                                              )
                                              .then(() => {
                                                _o_this.op_loadDtlAll({b_clr: false})
                                                .then(() => {
                                                  cf.myRN_savePageStgs({
                                                    sgc_pageMode: 'show',
                                                  })
                                                  .then(() => {
                                                    cf.myRN_chgPnlMode({
                                                      mode: 'list',
                                                    })
                                                    .then(() => {
                                                      cf.h();
                                                    });
                                                  });
                                                });
                                              });
                                            }
                                            else {
                                              _o_this.op_loadDtlAll({b_clr: false})
                                              .then(() => {
                                                cf.myRN_savePageStgs({
                                                  sgc_pageMode: 'show',
                                                })
                                                .then(() => {
                                                  cf.myRN_chgPnlMode({
                                                    mode: 'list',
                                                  })
                                                  .then(() => {
                                                    cf.h();
                                                  });
                                                });
                                              });
                                            };
                                          });
                                        })
                                      },
                                    },
                                    {
                                      pfx: 'いいえ',
                                      o_onPrs: () => {
                                      },
                                    }
                                  ]
                                });
                              }
                            },
                          })
                          : null,

                        ])
                      : null,


                      bf.i(_o_this.state.sgc_pageMode, ['new']) ?
                        ce.c(ce.Box, {
                          key: -160,
                          stlCta: {
                            flexDirection: 'row',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            width: ic.gn_bdyW - ic.m(2),
                            marginTop: ic.s(0.5), // 20211202
                            marginBottom: ic.s(0.5), // 20211202
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }
                        }, [
                          ce.c(ce.Btn, {
                            key: -1,
                            pfx: '前の画面に戻る',
                            stlBtn: {
                              width: ic.s(8),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                            },
                            o_onPrs: () => {
                              cf.myRN_chgPageMode({
                                mode: 'cclNew',
                              });
                            },
                          }),
                          ce.c(ce.Btn, {
                            key: -2,
                            pfx: '登録',
                            b_rvs: _o_this.state.sb_agr == 1 ? false : true,
                            stlBtn: {
                              width: ic.s(8),
                            },
                            o_onPrs: () => {
                              if (_o_this.state.sb_agr != 1) {
                                alert(`「${_o_this.state.sgcd_stgs._00060100}」を確認の上、「${_o_this.state.sgcd_stgs._00060100}を確認・同意する」をチェックして下さい。`)
                              }
                              else {
                                _o_this.$opb_chk()
                                .then( _b_res => {
//ff.l('I1zv2 1741: here')
                                  if (_b_res) {
                                    cf.myRN_chgPageMode({
                                      mode: 'endNew',
                                    })
                                    .then(() => {
//ff.l('I1zv2 1747: here')

                                      let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];

                                      if ( ff.n(_o_this.state.sgcd_stgs._00050310) == 10 ) {

                                        let _ttl = 
                                          (_o_this.d_viewDefs.class == 'i1zv2a') ? 
                                          `ご予約を受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`
                                        :  (_o_this.d_viewDefs.class == 'i1zv2b') ? 
                                          `エントリーを受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`
                                        :  (_o_this.d_viewDefs.class == 'i1zv2c') ? 
                                          `優先エントリーを受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`
                                        : null;
                                        let _msg = 
                                          (_o_this.d_viewDefs.class == 'i1zv2a') ? 
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
ご利用いただきまして誠にありがとうございます。
下記ご予約を受け付けましたので、ご連絡致します。
なお、本ご予約を変更する場合は、キャンセルした後、改めてご予約ください。

<<< ご予約内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------
${_o_this.state.sgcd_stgs._01050100}

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${_o_this.state.sgcd_stgs._00050100}
-------------------------------------------------
`
                                        :  (_o_this.d_viewDefs.class == 'i1zv2b') ? 
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
ご利用いただきまして誠にありがとうございます。
下記エントリーを受け付けましたので、ご連絡致します。
なお、本エントリーを変更する場合は、キャンセルした後、改めてエントリーしてください。

<<< エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------
${_o_this.state.sgcd_stgs._02030100}

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${_o_this.state.sgcd_stgs._00050100}
-------------------------------------------------
`
                                        :  (_o_this.d_viewDefs.class == 'i1zv2c') ? 
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
ご利用いただきまして誠にありがとうございます。
下記優先エントリーを受け付けましたので、ご連絡致します。
なお、本優先エントリーを変更する場合は、キャンセルした後、改めて優先エントリーしてください。

<<< 優先エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------
${_o_this.state.sgcd_stgs._06030100}

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${_o_this.state.sgcd_stgs._00050100}
-------------------------------------------------
`
                                        : null;
                                        const _l_tos = [];
                                        if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                        if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                        if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                        const _l_bccs = [ic.g_mail];
                                        if (ff.f(_o_this.state.sgcd_stgs._00050200)) _l_bccs.push(_o_this.state.sgcd_stgs._00050200);                                  
  //ff.l('I1zv2 1831: here')
                                        cf.myCB_call_eml(
                                          _l_tos,
                                          _ttl,
                                          _msg,
                                          _l_bccs
                                        )
                                        .then(() => {
  //ff.l('I1zv2 1839: {} / {} / {} / {}'.f(_l_tos, _ttl, _msg, _l_bccs))
                                          cf.myRN_showMdl({
                                            mdl: 'cfm',
                                            msg: 
                                            (_o_this.d_viewDefs.class == 'i1zv2a') ? 
                                              `予約が完了しました`
                                            : (_o_this.d_viewDefs.class == 'i1zv2b') ? 
                                              `エントリーが完了しました`
                                            : (_o_this.d_viewDefs.class == 'i1zv2c') ? 
                                              `優先エントリーが完了しました`
                                            : null,
                                            ld_btnss: [
                                              {
                                                pfx: 'ＯＫ',
                                                o_onPrs: () => { // 一覧には戻らない
  //ff.l('I1zv2 1854: here');
/*
                                                  cf.myRN_chgPageMode({
                                                    mode: 'cclNew',
                                                  })
                                                  .then(() => {
                                                    location.reload(); // 新規登録後に線が表示されなることへの対応（暫定）
                                                  });
*/
                                                },
                                              },
                                            ]
                                          });
                                        });
                                      }
                                      else {
                                        cf.myRN_showMdl({
                                          mdl: 'cfm',
                                          msg: 
                                          (_o_this.d_viewDefs.class == 'i1zv2a') ? 
                                            `予約が完了しました`
                                          : (_o_this.d_viewDefs.class == 'i1zv2b') ? 
                                            `エントリーが完了しました`
                                          : (_o_this.d_viewDefs.class == 'i1zv2c') ? 
                                            `優先エントリーが完了しました`
                                          : null,
                                          ld_btnss: [
                                            {
                                              pfx: 'ＯＫ',
                                              o_onPrs: () => {
//ff.l('I1zv2 1854: here');
                                                cf.myRN_chgPageMode({
                                                  mode: 'cclNew',
                                                })
                                                .then(() => {
                                                  location.reload(); // 新規登録後に線が表示されなることへの対応（暫定）
                                                });
                                              },
                                            },
                                          ]
                                        });
                                      };
                                    });
                                  };
                                })
                              };
                            },
                          })
                        ])
                      : null,

                      bf.i(_o_this.state.sgc_pageMode, ['edit']) ?
                        ce.c(ce.Box, {
                          key: -170,
                          stlCta: {
                            flexDirection: 'row',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            width: ic.gn_bdyW - ic.m(2),
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }
                        }, [

                          ce.c(ce.Btn, {
                            key: -1,
                            pfx: '戻る',
                            stlCta: {
                              marginTop: (ic.g_dvcMode == 's') ? ic.s(0.5) : null // 20211202
                            },
                            stlBtn: {
                              width: ic.s(8),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                            },
                            o_onPrs: () => {
                              cf.myRN_chgPageMode({
                                mode: 'cclEdit',
                              });
                            },
                          }),

                          ce.c(ce.Btn, {
                            key: -2,
                            pfx: '登録',
                            b_rvs: _o_this.state.sb_chk == true ? false : true,
                            stlCta: {
                              marginTop: (ic.g_dvcMode == 's') ? ic.s(0.5) : null // 20211202
                            },
                            stlBtn: {
                              width: ic.s(8),
                            },
                            o_onPrs: () => {
                              if (_o_this.state.sb_chk != true) {
                                alert(`「${_o_this.state.sgcd_stgs._00060100}」を確認の上、「${_o_this.state.sgcd_stgs._00060100}を確認・同意する」をチェックして下さい。`)
                              }
                              else {
                                _o_this.$opb_chk()
                                .then( _b_res => {
                                  if (_b_res) {
                                    cf.myRN_chgPageMode({
                                      mode: 'endEdit',
                                    });
                                  };
                                })
                              };
                            },
                          }),

                          ce.c(ce.Btn, {
                            key: -3,
                            pfx: 'キャンセル',
                            stlCta: {
                              marginTop: (ic.g_dvcMode == 's') ? ic.s(0.5) : null // 20211202
                            },
                            stlBtn: {
                              width: ic.s(8),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                            },
                            o_onPrs: 
                              (_o_this.d_viewDefs.class == 'i1zv2a') ?
                                () => {
                                  let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];
                                  let _d_i14rs = _o_this.state.sdld_i14rDtlsss.i14r[0];
                                  let _n_days = ff.myDT_getDff('day', ff.myDT_getDate('today'), _d_i1zrs.d_flds.i1zri21d);
                                  if ( _d_i1zrs.d_flds.i1z1s11i == 10 || _n_days < _d_i14rs.d_flds.i14ri31i ) {
                                    cf.myRN_showMdl({
                                      mdl: 'cfm',
//                                      msg: `利用料の支払い前、かつ、利用日から${_d_i14rs.d_flds.i14ri31i}日以上前の場合のみキャンセルできます(支払い済の予約をキャンセルする場合は、電話か、直接窓口にお越しください)`,
                                      msg: `利用日から${_d_i14rs.d_flds.i14ri31i}日以上前の場合のみキャンセルできます(当日の予約をキャンセルする場合は、電話か、直接窓口にお越しください)`,
                                      ld_btnss: [
                                        {
                                          pfx: 'はい',
                                          o_onPrs: () => {
                                          },
                                        },
                                      ]
                                    });
                                  }
                                  else {
                                    cf.myRN_showMdl({
                                      mdl: 'cfm',
                                      msg: 'キャンセルして宜しいですか？',
                                      ld_btnss: [
                                        {
                                          pfx: 'はい',
                                          o_onPrs: () => {
                                            cf.s();
                                            cf.myRN_setDat('sdld_i1zrDtlsss', _o_this.state.sdld_i1zrDtlsss.i1zr[0], _d_dats => {
                                              let _d = {
                                                i1zrs11i: 20,
                                              };
                                              return _d;
                                            })
                                            .then(() => {
                                              _o_this.op_upd()
                                              .then(() => {
                                                _o_this.op_loadDtlAll({b_clr: false})
                                                .then(() => {
                                                  cf.myRN_savePageStgs({
                                                    sgc_pageMode: 'show',
                                                  })
                                                  .then(() => {
                                                    cf.h();
                                                  });
                                                });
                                              });
                                            })
                                          },
                                        },
                                        {
                                          pfx: 'いいえ',
                                          o_onPrs: () => {
                                          },
                                        }
                                      ]
                                    });
                                  }
                                }

                              : (_o_this.d_viewDefs.class == 'i1zv2b') ?
                                () => {
                                  let _d_i14rs = _o_this.state.sdld_i14rDtlsss.i14r[0];
                                  let _today = ff.myDT_getDate('today');
                                  let _stt = ff.myDT_add('day', ff.myDT_cnv('fdm', _today), _d_i14rs.d_flds.i14ri42i - 1);
                                  let _end = ff.myDT_add('day', ff.myDT_cnv('fdm', _today), _d_i14rs.d_flds.i14ri52i - 1);
                                  if ( _today < _stt || _end < _today ) {
                                    cf.myRN_showMdl({
                                      mdl: 'cfm',
                                      msg: 'エントリー受付期間のみキャンセルできます',
                                      ld_btnss: [
                                        {
                                          pfx: 'はい',
                                          o_onPrs: () => {
                                          },
                                        },
                                      ]
                                    });
                                  }
                                  else {
                                    cf.myRN_showMdl({
                                      mdl: 'cfm',
                                      msg: 'キャンセルして宜しいですか？',
                                      ld_btnss: [
                                        {
                                          pfx: 'はい',
                                          o_onPrs: () => {
                                            cf.s();
                                            cf.myRN_setDat('sdld_i1zrDtlsss', _o_this.state.sdld_i1zrDtlsss.i1zr[0], _d_dats => {
                                              let _d = {
                                                i1zrs21i: 20,
                                              };
                                              return _d;
                                            })
                                            .then(() => {
                                              _o_this.op_upd()
                                              .then(() => {
                                                _o_this.op_loadDtlAll({b_clr: false})
                                                .then(() => {
                                                  cf.myRN_savePageStgs({
                                                    sgc_pageMode: 'show',
                                                  })
                                                  .then(() => {
                                                    cf.h();
                                                  });
                                                });
                                              });
                                            })
                                          },
                                        },
                                        {
                                          pfx: 'いいえ',
                                          o_onPrs: () => {
                                          },
                                        }
                                      ]
                                    });
                                  }
                                }

                              : (_o_this.d_viewDefs.class == 'i1zv2c') ?
                                () => {
                                  let _d_i14rs = _o_this.state.sdld_i14rDtlsss.i14r[0];
                                  let _today = ff.myDT_getDate('today');
                                  let _stt = ff.myDT_add('day', ff.myDT_cnv('fdm', _today), _d_i14rs.d_flds.i14ri42i - 1);
                                  let _end = ff.myDT_add('day', ff.myDT_cnv('fdm', _today), _d_i14rs.d_flds.i14ri52i - 1);
                                  if ( _today < _stt || _end < _today ) {
                                    cf.myRN_showMdl({
                                      mdl: 'cfm',
                                      msg: '優先エントリー受付期間のみキャンセルできます',
                                      ld_btnss: [
                                        {
                                          pfx: 'はい',
                                          o_onPrs: () => {
                                          },
                                        },
                                      ]
                                    });
                                  }
                                  else {
                                    cf.myRN_showMdl({
                                      mdl: 'cfm',
                                      msg: 'キャンセルして宜しいですか？',
                                      ld_btnss: [
                                        {
                                          pfx: 'はい',
                                          o_onPrs: () => {
                                            cf.s();
                                            cf.myRN_setDat('sdld_i1zrDtlsss', _o_this.state.sdld_i1zrDtlsss.i1zr[0], _d_dats => {
                                              let _d = {
                                                i1zrs22i: 20,
                                              };
                                              return _d;
                                            })
                                            .then(() => {
                                              _o_this.op_upd()
                                              .then(() => {
                                                _o_this.op_loadDtlAll({b_clr: false})
                                                .then(() => {
                                                  cf.myRN_savePageStgs({
                                                    sgc_pageMode: 'show',
                                                  })
                                                  .then(() => {
                                                    cf.h();
                                                  });
                                                });
                                              });
                                            })
                                          },
                                        },
                                        {
                                          pfx: 'いいえ',
                                          o_onPrs: () => {
                                          },
                                        }
                                      ]
                                    });
                                  }
                                }

                              : null,
                          }),

                        ])
                      : null,

                  ],
                },
              }),

            ],
          }
        }

      : {}
    )
  );
}

}
